(function () {
  'use strict';
  if (window.soCartStateSync) return;

  let revision = 0;
  let refreshTimer;
  let currentCart = null;
  const source = 'so-cart-sync';
  const validCart = cart => cart && Array.isArray(cart.items) &&
    Number.isFinite(Number(cart.item_count)) && Number.isFinite(Number(cart.total_price));
  const rootPath = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const onCartPage = () => window.location.pathname.replace(/\/+$/, '') ===
    (rootPath().replace(/\/$/, '') + '/cart');

  function applyCart(cart) {
    if (!validCart(cart)) return;
    currentCart = cart;
    const count = Math.max(0, Number(cart.item_count));
    if (window.theme) window.theme.cartItemCount = count;
    const store = window.Alpine && window.Alpine.store && window.Alpine.store('cart_count');
    if (store) store.count = count;

    document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble, .snav-cart-count')
      .forEach(badge => {
        const label = badge.querySelector('span') || badge;
        label.textContent = String(count);
        badge.style.display = count > 0 ? '' : 'none';
      });

    ['updateCartDisplay', 'updateShippingProgress', 'updateFree1gBanner'].forEach(name => {
      if (typeof window[name] === 'function') window[name](cart);
    });
    const page = document.querySelector('.so-cart');
    if (page) {
      page.classList.toggle('so-cart--empty', count === 0);
      const summary = page.querySelector('.so-cart__summary');
      if (summary) summary.hidden = count === 0;
      const continueLink = page.querySelector('.so-cart__continue');
      if (continueLink) continueLink.hidden = count === 0;
    }
  }

  async function renderCartPage(token) {
    if (!onCartPage()) return;
    const page = document.querySelector('.so-cart');
    const wrapper = page && page.closest('[id^="shopify-section-"]');
    if (!wrapper) return;
    const sectionId = wrapper.id.replace('shopify-section-', '');
    const url = new URL(window.location.href);
    url.searchParams.set('sections', sectionId);
    const response = await fetch(url.href, {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to refresh the cart page');
    const sections = await response.json();
    if (token !== revision) return;
    if (typeof sections[sectionId] !== 'string') throw new Error('Cart page section is missing');
    const parsed = new DOMParser().parseFromString(sections[sectionId], 'text/html');
    const fresh = parsed.getElementById(wrapper.id);
    if (!fresh) throw new Error('Cart page markup is missing');
    if (window.Alpine && typeof window.Alpine.morph === 'function') {
      window.Alpine.morph(wrapper, fresh.outerHTML);
    } else {
      wrapper.replaceWith(fresh);
    }
  }

  async function refresh() {
    const token = ++revision;
    try {
      const response = await fetch(rootPath() + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Unable to refresh the cart');
      let cart = await response.json();
      if (token !== revision || !validCart(cart)) return null;
      if (typeof window.enforceCartLocks === 'function') cart = await window.enforceCartLocks(cart);
      if (token !== revision || !validCart(cart)) return null;
      applyCart(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source } }));
      await renderCartPage(token);
      return token === revision ? cart : null;
    } catch (error) {
      if (token === revision) console.warn('Cart synchronization deferred:', error);
      return null;
    }
  }

  function queueRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 0);
  }

  function onCartEvent(event) {
    if (event.detail && event.detail.source === source) return;
    revision += 1;
    const cart = event.detail && (event.detail.cart || event.detail.response);
    if (validCart(cart)) applyCart(cart);
    queueRefresh();
  }

  ['shapes:cart:afteradditem', 'shapes:cart:cartqtychange', 'shapes:cart:update']
    .forEach(name => window.addEventListener(name, onCartEvent, true));
  ['cart:updated', 'cart:refresh'].forEach(name => document.addEventListener(name, onCartEvent));
  window.addEventListener('pageshow', queueRefresh);
  document.addEventListener('alpine:initialized', () => {
    if (currentCart) applyCart(currentCart);
  });

  window.soCartStateSync = { refresh };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueRefresh, { once: true });
  } else {
    queueRefresh();
  }
})();
